import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { indexItemsById } from '@/helpers/IndexHelpers';
import FormInput2 from '@/components/forms/FormInput2.vue';
@Component({
    name: 'AdmitDetailsFields',
    components: { FormInput2 },
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    quantities;
    @Prop({ required: true })
    event;
    @Prop({ required: true })
    value;
    internal = {};
    t;
    get fields() {
        const types = indexItemsById(this.event.ticketTypes);
        const nameConfig = {};
        const emailConfig = {};
        const eventMeta = this.event.meta;
        for (const group of this.event.ticketGroups) {
            const groupMeta = group.meta;
            nameConfig[group.id] = (groupMeta.admit_names || eventMeta.admit_names || 'disabled');
            emailConfig[group.id] = (groupMeta.admit_emails || eventMeta.admit_emails || 'disabled');
        }
        const result = [];
        for (const typeId in this.quantities) {
            const quantity = this.quantities[typeId].quantity;
            const ticketType = types[typeId];
            const config = nameConfig[ticketType.ticket_group_id];
            if (config !== 'disabled' && quantity) {
                for (let i = 0; i < quantity; i++) {
                    const ttName = ticketType.name;
                    const number = i + 1;
                    result.push({
                        index: i,
                        label: this.$t('admitDetailsFields.label', { ttName, number }),
                        key: `${ticketType.id}-${i}`,
                        ticketTypeId: ticketType.id,
                        required: config === 'required',
                        email: emailConfig[ticketType.ticket_group_id],
                    });
                }
            }
        }
        return result;
    }
    @Watch('internal', { deep: true })
    onNamesChange() {
        this.$emit('input', this.internal);
    }
    @Watch('quantities', { deep: true, immediate: true })
    initNames() {
        for (const ttId in this.quantities) {
            const names = [];
            const quantity = this.quantities[ttId].quantity;
            for (let i = 0; i < quantity; i++) {
                names[i] = this.value[ttId]?.[i] ?? { name: '' };
            }
            Vue.set(this.internal, ttId, names);
        }
    }
    nameLabel(email, label) {
        if (email !== 'disabled') {
            return 'Full Name';
        }
        else {
            return `${label} Full Name`;
        }
    }
}
